import server from 'common/utils/server';

export const solicitationsState = (
  state = {
    reviewRecSolicitationsById: {},
    apiSolicitations: [],
  },
  action
) => {
  switch (action.type) {
    case 'solicitations/RECEIVED_STREAM_SOLICITATIONS': {
      const reviewRecSolicitationsById = {
        ...state.reviewRecSolicitationsById,
      };
      action.value.solicitations.forEach(solicitation => {
        reviewRecSolicitationsById[solicitation.id] = solicitation;
      });
      return { ...state, reviewRecSolicitationsById };
    }
    case 'solicitations/RECEIVED_API_SOLICITATIONS': {
      const { apiSolicitations } = action;
      return {
        ...state,
        apiSolicitations: [
          ...apiSolicitations,
          ...state.apiSolicitations.filter(
            s => !apiSolicitations.some(oldS => oldS.id === s.id)
          ),
        ],
      };
    }
    default: {
      return state;
    }
  }
};

export const getApiSolicitations =
  (params = {}) =>
  dispatch => {
    server
      .get('/api/v1/stream', {
        ...params,
        skip_session: true,
      })
      .then(({ solicitations }) => {
        const apiSolicitations = solicitations.map(s => ({
          id: s.id,
          followUpIds: s.follow_up_ids || [],
          externalUrl: s.external_url || '',
          answers: s.answers.map(answer => ({
            questionId: answer.question_id,
            comment: answer.comment,
            selectedOptionIds: answer.selected_option_ids,
            questionType: answer.questionType,
            questionText: answer.questionText,
          })),
          stars: s.stars,
          respondedAt: s.responded_at,
          comments: s.comments,
          extInteractionId: s.ext_interaction_id,
        }));
        dispatch({
          type: 'solicitations/RECEIVED_API_SOLICITATIONS',
          apiSolicitations,
        });
      });
  };
